<template>
  <el-dialog :lock-scroll="true" :visible.sync="visible" width="100%">
    <div class="discount-popup">
      <div class="ribbon">
        <div :style="{ backgroundImage: `url('${$root.cdn_url}/assets/images/splash/ribbon-part-1.svg')` }"></div>
        <div :style="{ backgroundImage: `url('${$root.cdn_url}/assets/images/splash/ribbon-part-3.svg')` }">
          {{ $t("exit_popup.sale") }}
        </div>
        <div :style="{ backgroundImage: `url('${$root.cdn_url}/assets/images/splash/ribbon-part-2.svg')` }"></div>
      </div>

      <h2>{{ $t("exit_popup.save_extra") }}</h2>
      <p v-html="$t('exit_popup.promo_description')"></p>

      <div>
        <timer-component :startMinutes="5" :title="' '" />
      </div>

      <div class="button" @click="applyDiscount">
        <Spinner v-if="isLoading" size="small" color="dark" class="mr-3 align-middle" />
        <div class="d-inline" v-html="isLoading ? $t('exit_popup.loading_button') : $t('exit_popup.activate_button')"></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Spinner from "./preloaders/Spinner";
import isMobile from "./../../mixins/isMobile";

let timer,
  scrollDelta = 0,
  scrollLastPos = null;

let savedURL;

export default {
  name: "DiscountPopup",
  props: ["$v"],
  components: { Spinner },
  mixins: [isMobile],

  data() {
    return {
      visible: false,
      isShown: false,
      sensitivity: 10, // triggering border space in pixels
      speedSensitivity: 70,
      isLoading: false,
      shouldTriggerMobile: false
    };
  },

  methods: {
    mouseEvent(event) {
      const shouldShow = !event.toElement && !event.relatedTarget && event.clientY < this.sensitivity;
      if (shouldShow) {
        this.showPopup();
      }
    },

    scrollEvent(event) {
      if (!this.shouldTriggerMobile && window.scrollY > document.documentElement.scrollHeight * 0.3) {
        this.shouldTriggerMobile = true;
      }

      // record scroll speed
      const newPos = window.scrollY;
      if (scrollLastPos != null) {
        scrollDelta = newPos - scrollLastPos;
      }
      scrollLastPos = newPos;
      clearTimeout(timer);
      timer = setTimeout(() => {
        scrollLastPos = null;
        scrollDelta = 0;
      }, 50);

      // scrolled more than 30% document than scrolled fast up - show popup
      if (!this.isShown && this.shouldTriggerMobile && scrollDelta < -this.speedSensitivity) {
        this.showPopup();
      }
    },

    showPopup() {
      if (localStorage.getItem('leave_modal_mute')) {
        return false;
      }
      document.removeEventListener("mouseout", this.mouseEvent);
      this.visible = true;
      this.isShown = true;
    },

    applyDiscount() {
      this.$emit("apply");
      this.isLoading = true;
      window.location = window.location.href.split("#")[0] + (window.location.href.indexOf("?") !== -1 ? "&" : "?") + "coupon=10off";

      // save user inputs
      if (this.$v) {
        const formData = JSON.stringify(
          Object.keys(this.$v.form).map(key => {
            return { name: key, value: this.$v.form[key].$model };
          })
        );
        localStorage.setItem('saved_form', formData);
      }
    }
  },

  mounted() {
    if (this.$root.is_exit_popup == 0 || js_query_params.exit == "0" || localStorage.getItem("leave_modal_mute")) {
      return;
    }

    savedURL = window.location.href;

    // navigate to empty hash and start tracking change
    setTimeout(() => {
      window.location.href = "#";
    }, 1000);

    window.addEventListener("hashchange", e => {
      const oldURL = e.oldURL ?? savedURL;
      const newURL = e.newURL ?? window.location.href;

      if (oldURL.length > newURL.length && !this.isShown) {
        this.showPopup();
        e.preventDefault();
      }

      savedURL = newURL;
    });

    // delay popup init for few seconds
    setTimeout(() => {
      // todo: limit for specific customer
      if (true) {
        document.addEventListener("mouseout", this.mouseEvent);
      }
    }, 10 * 1000); // delay 10 secs before activating popup

    // mobile popup
    if (this.isMobile) {
      setTimeout(() => {
        document.addEventListener("scroll", this.scrollEvent);
      }, 20 * 1000); // delay 30 before applying mobile popup rules
    }
  }
};
</script>

<style lang="scss">
.el-dialog {
  max-width: 600px;
}
.el-dialog__header {
  border-bottom: 0;
}

// override some timer styles
.discount-popup .timer-component .mobile {
  background-color: transparent;
  color: black;
  font-size: 22px;
}

.discount-popup {
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  word-break: normal;

  .ribbon {
    display: flex;
    margin: auto;
    margin-bottom: 20px;
    height: 60px;

    [dir="rtl"] & {
      flex-direction: row-reverse;
    }

    > div {
      background-size: 50%;
      &:nth-child(1) {
        width: 64px;
        background-size: 100%;
      }
      &:nth-child(2) {
        font-weight: bold;
        color: white;
        font-size: 1.5em;
        line-height: 20px;
        background-size: 142px;
        padding: 6px 20px;
        text-transform: uppercase;
      }
      &:nth-child(3) {
        width: 64px;
        background-size: 100%;
      }
    }
  }

  h2 {
    font-weight: bold;
    line-height: 1.5em;
  }

  p {
    font-size: 16px;
    margin: 12px 0;
  }

  .button {
    width: 100%;
    background-color: #fec31d;
    text-align: center;
    font-weight: bold;
    margin-top: 36px;
    padding: 10px;
    font-size: 15px;
    border-radius: 3px;
    cursor: pointer;

    span {
      color: #b51217;
    }

    &:hover {
      background-color: #f8d471;
    }
  }
}
</style>
